/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react';
import { Tabs, LoadingIndicator } from '@components';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { PlanoParticipanteService } from '../../../common/services/planoParticipante';
import { ParcelaAdicionalForm } from './Formulario';
import { ParcelaAdicionalHistorico } from './Historico';

const service = new PlanoParticipanteService();

export const ParcelaAdicionalPage = () => {
  const [activeTab, setActiveTab] = useState(
    'Registro de opção de parcela adicional'
  );

  const [loading, setLoading] = useState(false);
  const matricula = useSelector((state) => state.user.data?.matricula);

  const [dadosParcelaAdicional, setDadosParcelaAdicional] = useState({
    CdConsistencia: null,
    MsgConsistencia: null,
    historico: [],
  });

  const handleRegistraOpcao = useCallback(
    (opcao) => {
      setLoading(true);
      service
        .registrarSolicitacaoPagamento13(matricula, opcao)
        .then((res) => {
          if (res.success) {
            toast.success(res.message);
          } else {
            toast.error(res.message);
          }
        })
        .catch(() => {
          toast.error('Erro ao enviar parcela adicional.');
        })
        .finally(() => {
          service
            .obterDadosDecimoTerceiro(matricula)
            .then((res) => setDadosParcelaAdicional(res))
            .finally(() => setLoading(false));

          if (opcao === 'S') {
            setActiveTab('Acompanhamento de pedidos de parcela adicional');
          } else {
            setActiveTab('Registro de opção de parcela adicional');
          }
        });
    },
    [matricula]
  );

  useEffect(() => {
    setLoading(true);
    service
      .obterDadosDecimoTerceiro(matricula)
      .then((res) => {
        setDadosParcelaAdicional(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [matricula, handleRegistraOpcao]);

  return (
    <>
      <Helmet>
        <title>Forluz - Parcela Adicional</title>
      </Helmet>

      <h1 className="fw-bold page-title mb-32 mb-md-5">
        Registro de opção de parcela adicional
      </h1>
      {!loading ? (
        <Tabs active={activeTab}>
          <div
            label="Registro de opção de parcela adicional"
            onClick={() =>
              setActiveTab('Registro de opção de parcela adicional')
            }
            aria-hidden
          >
            <ParcelaAdicionalForm
              dadosParcelaAdicional={dadosParcelaAdicional}
              handleRegistraOpcao={handleRegistraOpcao}
            />
          </div>
          <div
            label="Acompanhamento de pedidos de parcela adicional"
            onClick={() => {
              setActiveTab('Acompanhamento de pedidos de parcela adicional');
            }}
            aria-hidden
          >
            <ParcelaAdicionalHistorico
              dadosParcelaAdicional={dadosParcelaAdicional}
              handleRegistraOpcao={handleRegistraOpcao}
            />
          </div>
        </Tabs>
      ) : (
        <LoadingIndicator />
      )}
    </>
  );
};
